import * as React from "react";
import CellBase from "./cell-base.js";
import CellBrief from "./cell-brief.js";
import CellTitle from "./cell-title.js";
import CellValue from "./cell-value.js";
function Cell(props) {
    const { title, brief, children, titleStyle, titleClass, valueClass, briefClass, ...restProps } = props;
    return (React.createElement(CellBase, { ...restProps },
        title && (React.createElement(CellTitle, { titleStyle: titleStyle, titleClass: titleClass },
            title,
            brief && React.createElement(CellBrief, { children: brief, briefClass: briefClass }))),
        React.createElement(CellValue, { alone: !title, children: children })));
}
export default Cell;
